import React, { Component } from "react";
import { Loader } from "semantic-ui-react";

class InitLoader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaderText: "",
    };
  }

  changeLoaderText = (newText) => {
    this.setState({ loaderText: newText });
  }

  render() {
    return (
      <Loader size="huge" indeterminate>
        {this.state.loaderText}
      </Loader>
    );
  }
}

export default InitLoader;
